import Theme from 'core/themes/model'

export const gridContainer = (theme: Theme) =>
  ({
    display: 'grid',
    width: '100%',
    gridTemplateColumns: 'repeat(2, minmax(510px, 1fr))',
    [theme.breakpoints.down(1400)]: {
      gridTemplateColumns: 'repeat(2, minmax(450px, 1fr))',
    },
    [theme.breakpoints.up(1500)]: {
      gridTemplateColumns: 'repeat(3, minmax(372px, 1fr))',
    },
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  } as any)
